import {Component, Input, OnInit,} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MatTableDataSource} from '@angular/material/table';
import {AppTranslateService} from '../../../../../modules/services/translate/app-translate.service';

@Component({
    selector: 'app-recap-info-general-acheteur',
    templateUrl: './recap-info-general-acheteur.component.html',
    styleUrls: ['./recap-info-general-acheteur.component.css'],
})
export class RecapInfoGeneralAcheteurComponent implements OnInit {
    labels = [
        'N° de réception',
        'Code acheteur public',
        'acheteur_public',
        'nom_achteur_ar',
        'nom_achteur_en',
        'abb_achteur_fr',
        'abb_achteur_ar',
        'matricule_fiscale',
        'affile',
        'codepostale',
        'adresee',
        'adress2',
        'site_web',
        'nom_premier_resp',
        'fonction_premier_resp',
        'email',
    ];
    lables2 = [
        'nom_prenom',
        'iden_unique_fonctionaire',
        'departrement',
        'Fonction',
        'tel_fixe',
        'fax',
        'tel_port',
    ];
    dataColumns2 = [
        'staffNm',
        'officialsId',
        'staffDeptNm',
        'positionNm',
        'telNo',
        'faxNo',
        'mtelNo',
    ];

    dataColumnsAr2 = [
        'staffNm',
        'officialsId',
        'staffDeptNm',
        'positionNm',
        'telNo',
        'faxNo',
        'mtelNo',
    ];
    dataColumnsEn2 = [
        'staffNm',
        'officialsId',
        'staffDeptNm',
        'positionNm',
        'telNo',
        'faxNo',
        'mtelNo',
    ];

    label = 'general_information';
    label2 = 'info_interlocuteur_unique';
    @Input() data = [];
    transposedData = [];
    displayedColumns = [];

    dataColumns = [
        'instRcvNo',
        'instRegNo',
        'instNm', //achteur
        'instNmAr', //nom_arabe
        'instNmEn', //nom_en
        'instNmAbbr', //abbfr
        'instNmAbbrAr',
        'taxId', //matfiscale
        'affilie', //affile
        'postCd', //codepostale
        'addr1', //adresse1
        'addr2', //adresse2
        'hpage', //site
        'chfNm',
        'chfPosition',
        'email',
    ];

    dataColumnsAr = [
        'instRcvNo',
        'instRegNo',
        'instNm', //achteur
        'instNmAr', //nom_arabe
        'instNmEn', //nom_en
        'instNmAbbr', //abbfr
        'instNmAbbrAr',
        'taxId', //matfiscale
        'affilie', //affile
        'postCd', //codepostale
        'addr1', //adresse1
        'addr2', //adresse2
        'hpage', //site
        'chfNm',
        'chfPosition',
        'email',
    ];
    dataColumnsEn = [
        'instRcvNo',
        'instRegNo',
        'instNm', //achteur
        'instNmAr', //nom_arabe
        'instNmEn', //nom_en
        'instNmAbbr', //abbfr
        'instNmAbbrAr',
        'taxId', //matfiscale
        'affilie', //affile
        'postCd', //codepostale
        'addr1', //adresse1
        'addr2', //adresse2
        'hpage', //site
        'chfNm',
        'chfPosition',
        'email',
    ];

    dataSource: MatTableDataSource<any>;
    @Input() langue: string;

    constructor(
        private translate: TranslateService,
        private appTranslateService: AppTranslateService
    ) {
        this.langue = this.getlang();
    }

    getlang() {
        return this.appTranslateService.getDefaultLang();
    }

    ngOnInit(): void {
    }
}
